import { React, classNames } from '@digsup/core-ui';
import { LabBg } from './assets/LabBg';
import svgLabBgTop from './assets/lab-bg-top.svg';
import svgLabBgBubblesGroup from './assets/lab-bg-bubbles-group.svg';
import { styles } from './LabAsset.scss';

const cx = classNames.bind(styles);

export const LabAsset = () => (
  <div className={cx('l-homepage-hero-lab-asset')}>
    <div className="l-homepage-hero-lab-asset__inner">
      <LabBg className="l-homepage-hero-lab-asset__bg" />
      <div className="l-homepage-hero-lab-asset__bg-bubbles">
        <img
          width="355"
          height="169"
          src={svgLabBgBubblesGroup}
          alt=""
          className="l-homepage-hero-lab-asset__bg-bubble-group"
        />
        <img
          width="355"
          height="169"
          src={svgLabBgBubblesGroup}
          alt=""
          className="l-homepage-hero-lab-asset__bg-bubble-group"
        />
      </div>
      <img
        width="544px"
        height="267px"
        src={svgLabBgTop}
        alt=""
        className="l-homepage-hero-lab-asset__bg-top"
      />
      <div className="l-homepage-hero-lab-asset__flame l-homepage-hero-lab-asset__flame1">
        <LabAssetFlame />
      </div>
      <div className="l-homepage-hero-lab-asset__flame l-homepage-hero-lab-asset__flame2">
        <LabAssetFlame />
      </div>
      <div className="l-homepage-hero-lab-asset__flame l-homepage-hero-lab-asset__flame3">
        <LabAssetFlame />
      </div>
      <div className="l-homepage-hero-lab-asset__flame l-homepage-hero-lab-asset__flame4">
        <LabAssetFlame />
      </div>
      <div className="l-homepage-hero-lab-asset__waves">
        <div className="l-homepage-hero-lab-asset__wave l-homepage-hero-lab-asset__wave4" />
        <div className="l-homepage-hero-lab-asset__wave l-homepage-hero-lab-asset__wave3" />
        <div className="l-homepage-hero-lab-asset__wave l-homepage-hero-lab-asset__wave2" />
        <div className="l-homepage-hero-lab-asset__wave l-homepage-hero-lab-asset__wave1" />
      </div>
    </div>
  </div>
);

const LabAssetFlame = () => (
  <div className="l-homepage-hero-lab-asset-flame">
    <div className="l-homepage-hero-lab-asset-flame__item l-homepage-hero-lab-asset-flame__item--red" />
    <div className="l-homepage-hero-lab-asset-flame__item l-homepage-hero-lab-asset-flame__item--orange" />
    <div className="l-homepage-hero-lab-asset-flame__item l-homepage-hero-lab-asset-flame__item--yellow" />
    <div className="l-homepage-hero-lab-asset-flame__item l-homepage-hero-lab-asset-flame__item--white" />
  </div>
);
